import React from 'react';
import Hero from './components/grievance/Hero';
import Main from './components/grievance/Main';

const Grievance = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default Grievance;